<template>
    <tr :class="['clickable', { disabled: !isActive, updated: isLastVisited(entity.id) }]"
        @click="goToDetail($event, entity.id)">
        <td class="no_padding drag_drop"><span></span></td>
        <td class="no_padding"><span
					v-if="!$_updateActionAllowed"
					class="lock"
					:title="'Sdílená služba. Nelze editovat.' | translate"
					v-translate>
			</span>
            <input type="checkbox"
                   :id="entity.id"
                   :value="entity.id"
                   @click.stop
                   @change="onChange"
                   :checked="isChecked"
            />
            <label
					:for="entity.id"
					@click.stop
					v-translate>Vybrat
			</label>
        </td>
        <span class="lock" v-if="!$_updateActionAllowed" :title="'Sdílená služba. Nelze editovat.' | translate" v-translate>Zamčeno</span>
        <td :data-th="'Název' | translate" class="first_data"><strong>{{ entity.name }}</strong><span class="archive" v-if="!entity.assignable" :title="$gettext('Již není možné přiřazovat') | translate" v-translate>Již není možné přiřazovat</span></td>
        <td :data-th="'Operátor' | translate" v-if="$_readActionAllowedAllOrOwnAndGlobal">
          <entity-link :id="entity.id_operator" type="operator">{{ entity.operator_name }}</entity-link>
        </td>
        <td :data-th="'Business model' | translate" v-if="$_readActionAllowedAllOrOwnAndGlobal">
          <entity-link :id="entity.id_business_model" type="businessModel">{{ entity.business_model_name }}</entity-link>
        </td>
        <td :data-th="'Váha' | translate">{{ weight }}</td>
        <td :data-th="'Kanály' | translate" v-if="channelsCount">
            <span class="dotted" @click.stop="$refs.channelsmodalref.showModal(true)">
                {{ channelsCount }}
              <modal ref="channelsmodalref">
                <div slot="title"><translate>Kanály ve službě</translate> ({{channelsCount}})</div>
                <div slot="body">
                  <ul>
                    <li v-for="(item, index) in entity.channel_names" :key="'channels-'+index">
                      <entity-link :id="item.id" type="channel">{{ item.name }}</entity-link>
                    <channel-video-quality-label v-if="item.video_quality" :quality="item.video_quality"></channel-video-quality-label>
                    </li>
                  </ul>
                </div>
              </modal>
            </span>
        </td>
        <td :data-th="'Kanály' | translate" v-else></td>
        <td :data-th="'PVR' | translate">{{ pvrDays() }}</td>
        <td :data-th="'Volné minuty' | translate">{{ pvrMinutes() }}</td>
        <td :data-th="'Catchup' | translate">{{ catchup() }}</td>
        <td :data-th="'Timeshift' | translate">{{ timeshift() }}</td>
        <td :data-th="'Počet současně streamujících zařízení' | translate">{{ deviceCount() }}</td>
        <td :data-th="'Platnost od' | translate">{{ entity.valid_from }}</td>
        <td :data-th="'Platnost do' | translate">{{ entity.valid_to }}</td>
        <td class="no_padding edit">
            <div class="edit_inner">
                <a
						v-if="!isActive && $_updateActionAllowed"
						class="btn btn_action btn_grey btn_enable"
												:title="'Aktivovat' | translate"
						@click.prevent.stop="emitUpdateEntity({enabled: true})"
						v-translate>Aktivovat
				</a>
                <a
						v-if="isActive && $_updateActionAllowed"
						class="btn btn_action btn_grey btn_disable"
												:title="'Deaktivovat' | translate"
						@click.prevent.stop="emitUpdateEntity({enabled: false})"
						v-translate>Deaktivovat
				</a>
                <a
                    v-if="$_deleteActionAllowed"
						class="btn btn_action btn_delete"
												:title="'Smazat' | translate"
						@click.prevent.stop="emitDeleteEntity"
						v-translate>Smazat
				</a>
            </div>
        </td>
    </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"
import ChannelVideoQualityLabel from "../../common/ChannelVideoQualityLabel.vue";
import EntityLink from "../../common/EntityLink.vue";

export default {
		name: "ServiceRow",
		mixins: [rowActions],
    components: { EntityLink, ChannelVideoQualityLabel },
		data() {
			return {
				moduleName: 'services',
				detailPageRouteName: 'serviceDetail',
			}
		},
		computed: {
			isActive() {
				return this.entity.enabled
			},
			weight() {
				if (this.entity.weight > 0) {
					return this.entity.weight
				}
			},
			channelsCount() {
				if (this.entity.channels_count > 0) {
					return this.entity.channels_count
				}
			}
		},
    methods: {
      pvrDays() {
        if (this.entity.pvr_lifetime_in_days) {
          return this.entity.pvr_lifetime_in_days + " " + this.$gettext('dní')
        }
        return ''
      },
      pvrMinutes() {
        if (this.entity.pvr_free_minutes) {
          return this.entity.pvr_free_minutes + " " + this.$gettext('min')
        }
        return ''
      },
      catchup() {
        if (this.entity.catchup && this.entity.catchup_hours) {
          return this.entity.catchup_hours + " " + this.$gettext('h')
        }
        return ''
      },
      timeshift() {
        if (this.entity.timeshift === true) {
          return this.$gettext('Ano')
        }
        if (this.entity.timeshift === false) {
          return this.$gettext('Ne')
        }
        return ''
      },
      deviceCount() {
        if(this.entity.device_count){
          return this.entity.device_addon ? "+"+this.entity.device_count : this.entity.device_count;
        }
        return '';
      },
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/views/services/ServiceRow.vue